import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { SelectCardGroup } from '@gemini/ui';
import { useSelectPropertyData } from './useSelectPropertyData';
const SelectProperty = ({ propertyType, handlePropertyTypeChange, error, }) => {
    const { t, data } = useSelectPropertyData();
    return (_jsx(Box, { children: _jsx(SelectCardGroup, { items: data, label: t('Property_type'), name: "propertyType", onChange: handlePropertyTypeChange, type: "radio", value: propertyType, error: error }) }));
};
export default SelectProperty;
